import { render, staticRenderFns } from "./CenteredNutritionBar.vue?vue&type=template&id=25166c56&scoped=true"
import script from "./CenteredNutritionBar.vue?vue&type=script&lang=js"
export * from "./CenteredNutritionBar.vue?vue&type=script&lang=js"
import style0 from "./CenteredNutritionBar.vue?vue&type=style&index=0&id=25166c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25166c56",
  null
  
)

export default component.exports